import React from 'react';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { keycloak } from './utils/auth';
import CinRoutes from './routes';
import globalTheme from './utils/globalTheme';

const App: React.FC = () => (
  <ReactKeycloakProvider authClient={keycloak}>
    <ThemeProvider theme={globalTheme}>
      <CssBaseline />
      <CinRoutes />
    </ThemeProvider>
  </ReactKeycloakProvider>
);

export default App;
